 export const BASE_URL = "https://8scas2snw5.execute-api.us-east-1.amazonaws.com/prod/api"
 export const BRAINY_BASE_URL = "https://8scas2snw5.execute-api.us-east-1.amazonaws.com/prod/api/"
//export const BASE_URL = "http://localhost:4000/api"